import { useParams } from "react-router-dom";
import PageHero from "../components/PageHero";
import { legalPolicies } from "../data/siteContent";

export function LegalPage() {
  const { policy } = useParams();
  const content = legalPolicies[policy] || legalPolicies.privacy;
  return (
    <>
      <PageHero
        eyebrow={content.eyebrow}
        title={content.title}
        copy={content.intro}
      />
      <section id="content" className="section-space bg-white">
        <div className="container max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-slate">
            {content.updated}
          </p>
          <div className="mt-10 space-y-10">
            {content.sections.map(([title, copy]) => (
              <section key={title}>
                <h2 className="font-display text-2xl font-bold text-ink">
                  {title}
                </h2>
                <p className="mt-3 text-sm leading-8 text-slate">{copy}</p>
              </section>
            ))}
          </div>
          <div className="mt-12 rounded-3xl bg-mist p-6 text-sm leading-7 text-slate">
            <strong className="text-ink">Important:</strong> This is starter
            content for the product build and is not legal advice. The final
            version should be reviewed and approved before public launch.
          </div>
        </div>
      </section>
    </>
  );
}
